module.exports = __webpack_public_path__ + "img/Z86_01.0fffeba0.jpg";